import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

import { MenuService } from "../services/menu.service";
import { AppConfig } from "../../../../config/app.config";
import { UserFavoritesRequest } from "../services/Info/UserFavoritesRequest";
import { LocalstorageService, UserService } from "../../../shared";
import { MasterService } from "../services";
import { timer } from "rxjs";
import { DialogService } from "primeng/dynamicdialog";
import { Top5DialogComponent } from "../../login/top5-dialog/top5-dialog.component";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
declare var jQuery: any;

@Component({
	selector: "caass-menu",
	templateUrl: "./menu.component.html",
	styleUrls: ["menu.component.css"],
})
export class MenuComponent implements OnInit {
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private config: AppConfig,
		private menuService: MenuService,
		private userService: UserService,
		private masterService: MasterService,
		private dialogService: DialogService,
		private selectService: SchoolselectorService,
		private localService: LocalstorageService
	) {}

	VersionText: string = "";

	applicationItemList: any[];

	ngAfterViewInit() {
		jQuery("#side-menu").metisMenu();

		if (jQuery("body").hasClass("fixed-sidebar")) {
			jQuery(".sidebar-collapse").slimscroll({
				height: "100%",
			});
		}
	}

	ReloadingMenu: boolean = false;
	RefreshAllSubscription: any;
	RefreshFavoritesSubscription: any;
	InboxCountSubscription: any;
	InboxCount: any = 0;
	ReportInboxCountSubscription: any;
	ReportInboxCount: number = 0;
	RefreshMinutes: any = 5;
	SBMRefreshing: any = false;
	ReportRefreshing: any = false;
	SBMInboxTimerSubscription: any;
	ReportInboxTimerSubscription: any;

	SchoolSubscription: any;

	LastSchoolID: any = -1;
	SchoolID: any = -1;

	express: any = false;

	SearchFor: string = "";
	Searching: boolean = false;
	CollapseSubscription: any;

	UserB64: string = "";

	private getLinkName(applicationItem: string) {
		return "/" + this.ReplaceAllOccur(applicationItem, "|", "/").toLowerCase();
	}

	private getLink(applicationItem: any, externalLink: boolean) {
		document.documentElement.scrollTop = 0;

		console.log("getLink");
		console.log("applicationItem");
		console.log(applicationItem);
		console.log("externalLink");
		console.log(externalLink);

		if (externalLink == true) {
			window.location.href = applicationItem.RedirectURL;
		} else {
			window.location.href = "#/" + this.getLinkName(applicationItem.ApplicationItemKey);
		}
	}

	ngOnInit() {
		var user = this.userService.getCurrentUser();
		var JsonStr = JSON.stringify(user);
		this.UserB64 = btoa(JsonStr);

		this.CollapseSubscription = this.menuService.CollapseObservable.subscribe((data) => this.onResetSearch(data));

		this.LoadVersion();

		this.express = this.config.getConfig("express");

		this.applicationItemList = this.route.snapshot.data["menu"];

		for (var z = 0; z < this.applicationItemList.length; z++) {
			var next = this.applicationItemList[z];

			if (next.IsParent == 1 && next.Children.length == 0) {
				next.IsSingleItem = true;
				next.RouterLink = String(next.RouterLink).toLowerCase();
			} else {
				next.IsSingleItem = false;
			}
		}

		if (this.express) {
			this.applicationItemList = this.applicationItemList.filter((a) => {
				return a.ApplicationItemKey === "ExpressIDCardPrinting";
			});
		}

		var lstApplicationWithChildren = this.applicationItemList.filter((a) => {
			return a.Children.length > 0;
		});

		for (let applicationItem of lstApplicationWithChildren) {
			for (let child of applicationItem.Children) {
				child.RouterLink = "/" + this.ReplaceAllOccur(child.ApplicationItemKey, "|", "/").toLowerCase();

				if (child.ExternalLink == true) {
					console.log(child.RedirectURL);
					child.RedirectURL += "/" + this.UserB64;
				}

				if (child.Children.length > 0) {
					for (let child2 of child.Children) {
						child2.RouterLink = "/" + this.ReplaceAllOccur(child2.ApplicationItemKey, "|", "/").toLowerCase();

						if (child2.ExternalLink == true) {
							child2.RedirectURL += "/" + this.UserB64;
						}
					}
				}
			}
		}

		var lstRouterLinks = this.GetRouterLinks(this.applicationItemList);
		this.menuService.MenuIsLoaded(true, lstRouterLinks);

		this.RefreshAllSubscription = this.menuService.MenuRefreshAllObservable.subscribe((data) => this.MenuRefreshAll(data));
		this.RefreshFavoritesSubscription = this.menuService.MenuRefreshFavoritesObservable.subscribe((data) => this.MenuRefreshFavorites(data));

		this.loadSBMInboxCount();
		this.loadReportInboxCount();

		this.InboxCountSubscription = this.menuService.onInboxChange().subscribe((val) => {
			if (val == "Refresh") {
				this.loadSBMInboxCount();
			}
		});

		this.ReportInboxCountSubscription = this.menuService.onReportInboxChange().subscribe((val) => {
			if (val == "Refresh") {
				this.loadReportInboxCount();
			}
		});

		this.SchoolSubscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.SchoolID = school.SchoolID;

			var DashboardURL = "/";
			var URL = this.router.url;

			if (URL == DashboardURL) {
				if (this.SchoolID != this.LastSchoolID) {
					this.LastSchoolID = school.SchoolID;
					this.CheckTop5();
				}
			} else {
				this.LastSchoolID = school.SchoolID;
			}
		});

		this.FilterSetAll(true);
	}

	ngOnDestroy() {
		try {
			this.RefreshAllSubscription.unsubscribe();
		} catch (e) {
			e.toString();
		}
		try {
			this.RefreshFavoritesSubscription.unsubscribe();
		} catch (e) {
			e.toString();
		}
		try {
			this.InboxCountSubscription.unsubscribe();
		} catch (e) {
			e.toString();
		}
		try {
			this.ReportInboxCountSubscription.unsubscribe();
		} catch (e) {
			e.toString();
		}
		try {
			this.CollapseSubscription.unsubscribe();
		} catch (e) {
			e.toString();
		}
		try {
			this.SBMInboxTimerSubscription.unsubscribe();
		} catch (e) {
			e.toString();
		}
		try {
			this.ReportInboxTimerSubscription.unsubscribe();
		} catch (e) {
			e.toString();
		}
		try {
			this.SchoolSubscription.unsubscribe();
		} catch (e) {
			e.toString();
		}
	}

	/*var result = this.menuService.getApplicationItems();
  
      result.subscribe(
        response => {
          this.applicationItemList = response;
          var lstApplicationWithChildren = this.applicationItemList.filter(a => {
            return a.Children.length > 0
          });
  
  
          for (let applicationItem of lstApplicationWithChildren) {
            for (let child of applicationItem.Children) {
              child.RouterLink = "/" + child.ApplicationItemKey.replace("|", "/").toLowerCase();
            }
          }
        },
        error => {

        }
      )
    }*/
	activeRoute(routename: string): boolean {
		return this.router.url.toLowerCase().indexOf(routename.toLowerCase()) > -1;
	}

	ReplaceAllOccur(source: string, searchFor: string, replaceWith: string) {
		let ans: string = source;

		while (ans.indexOf(searchFor) != -1) {
			ans = ans.replace(searchFor, replaceWith);
		}

		return ans;
	}

	LoadVersion() {
		var result = this.menuService.GetCAASSVersion();
		result.subscribe(
			(response) => {
				var Data: any = response;

				if (Data.length > 0) {
					this.VersionText = Data[0];
				}
			},
			(error) => {}
		);
	}

	onUnFavorite(AppItemID) {
		let parms: UserFavoritesRequest = {
			UserID: this.userService.getCurrentUser().userID,
			ApplicationItemID: AppItemID,
		};

		var result = this.menuService.UserFavoriteDeleteByID(parms);
		result.subscribe(
			(response) => {
				// this.MenuRefreshFavorites("refresh");
				this.menuService.MenuRefreshFavorites("refresh"); //Use the service so that the top bar updates
			},
			(error) => {}
		);
	}

	MenuRefreshAll(data) {
		if (String(data).toLowerCase() == "refresh") {
			this.ReloadingMenu = true;

			var result = this.menuService.ApplicationItemGetList();
			result.subscribe(
				(response) => {
					var data: any = response;

					for (var z = 0; z < data.length; z++) {
						var next = data[z];

						if (next.IsParent == 1 && next.Children.length == 0) {
							next.IsSingleItem = true;
							next.RouterLink = String(next.RouterLink).toLowerCase();
						} else {
							next.IsSingleItem = false;
						}
					}

					if (this.express) {
						data = data.filter((a) => {
							return a.ApplicationItemKey === "ExpressIDCardPrinting";
						});
					}

					var lstApplicationWithChildren = data.filter((a) => {
						return a.Children.length > 0;
					});

					for (let applicationItem of lstApplicationWithChildren) {
						for (let child of applicationItem.Children) {
							child.RouterLink = "/" + this.ReplaceAllOccur(child.ApplicationItemKey, "|", "/").toLowerCase();
							if (child.Children.length > 0) {
								for (let child2 of child.Children) {
									child2.RouterLink = "/" + this.ReplaceAllOccur(child2.ApplicationItemKey, "|", "/").toLowerCase();
								}
							}
						}
					}

					this.route.snapshot.data["menu"] = data;
					this.SaveRouterLinks(data);

					//
					// Remove Missing Parents
					// Update Existing
					//
					for (var z = this.applicationItemList.length - 1; z >= 0; z--) {
						var nextParent = this.applicationItemList[z];

						//
						// Try to find parent in new data
						//
						var newParent = this.TryFindParent(nextParent.ApplicationItemKey, data);

						if (newParent == null) {
							this.applicationItemList.splice(z, 1);
						} else {
							nextParent.Children = newParent.Children;
						}
					}

					//
					// Add Missing
					//
					if (this.applicationItemList.length != data.length) {
						var oldInd: number = 0;
						var newInd: number = 0;

						while (oldInd < this.applicationItemList.length || newInd < data.length) {
							var oldItem = this.applicationItemList[oldInd];
							var newItem = data[newInd];

							if (String(oldItem.ApplicationItemKey) != String(newItem.ApplicationItemKey)) {
								this.applicationItemList.splice(oldInd, 0, newItem);
							}

							oldInd++;
							newInd++;
						}
					}

					//
					// OLD
					//
					// Remove Items
					//
					// for(var z = this.applicationItemList.length - 1; z >= 0; z--){
					//   var nextParent = this.applicationItemList[z];

					//   console.log("Next Parent");
					//   console.log(nextParent);

					//   //Search for App Item key in new data
					//   if(!this.CheckParent(nextParent.ApplicationItemKey, data)){
					//     console.log("Parent Missing");

					//     this.applicationItemList.splice(z, 1);
					//   }
					//   else{

					//     //
					//     // Remove Children that don't exist
					//     //
					//     for(var i = nextParent.Children.length-1; i >= 0; i--){
					//       var nextChild = nextParent.Children[i];

					//       console.log("Next Child");
					//       console.log(nextChild);

					//       if(!this.CheckChild(nextParent.ApplicationItemKey, nextChild.ApplicationItemKey, data)){
					//         nextParent.Children.splice(i, 1);
					//       }
					//     }
					//   }
					// }

					// //
					// // Add Missing
					// //
					// for(var z = 0; z < data.length; z++){

					// }

					// // this.applicationItemList = data;

					this.ReloadingMenu = false;

					this.menuService.CheckFavoriteTopBar("refresh");
				},
				(error) => {}
			);
		}
	}

	TryFindParent(key, lstData) {
		for (var z = 0; z < lstData.length; z++) {
			var next = lstData[z];

			if (String(next.ApplicationItemKey) == String(key)) {
				return next;
			}
		}

		return null;
	}

	//
	// Update Favorites
	//
	MenuRefreshFavorites(data) {
		if (String(data).toLowerCase() == "refresh") {
			this.ReloadingMenu = true;

			var result = this.menuService.ApplicationItemGetList();
			result.subscribe(
				(response) => {
					var data: any = response;

					var favoritesInMenu: any;
					var favoritesInList: any;

					for (var z = 0; z < data.length; z++) {
						var next = data[z];

						if (next.IsParent == 1 && next.Children.length == 0) {
							next.IsSingleItem = true;
							next.RouterLink = String(next.RouterLink).toLowerCase();
						} else {
							next.IsSingleItem = false;
						}

						if (next.ApplicationItemID == "4ff43b7e-baf8-4015-9df3-3f1f19db2314") {
							favoritesInList = next;
						}
					}

					if (this.express) {
						data = data.filter((a) => {
							return a.ApplicationItemKey === "ExpressIDCardPrinting";
						});
					}

					var lstApplicationWithChildren = data.filter((a) => {
						return a.Children.length > 0;
					});

					for (let applicationItem of lstApplicationWithChildren) {
						for (let child of applicationItem.Children) {
							child.RouterLink = "/" + this.ReplaceAllOccur(child.ApplicationItemKey, "|", "/").toLowerCase();
							if (child.Children.length > 0) {
								for (let child2 of child.Children) {
									child2.RouterLink = "/" + this.ReplaceAllOccur(child2.ApplicationItemKey, "|", "/").toLowerCase();
								}
							}
						}
					}

					this.masterService.setApplicationItemList(data);
					this.route.snapshot.data["menu"] = data;
					this.SaveRouterLinks(data);

					for (var z = 0; z < this.applicationItemList.length; z++) {
						var next = this.applicationItemList[z];

						if (next.ApplicationItemID == "4ff43b7e-baf8-4015-9df3-3f1f19db2314") {
							favoritesInMenu = next;
						}
					}

					if (favoritesInMenu != undefined && favoritesInList != undefined) {
						favoritesInMenu.Children = favoritesInList.Children;
					}

					this.ReloadingMenu = false;

					this.menuService.CheckFavoriteTopBar("refresh");
				},
				(error) => {}
			);
		}
	}

	private loadSBMInboxCount() {
		var result = this.menuService.InboxCountSelect();
		result.subscribe(
			(response) => {
				this.InboxCount = response[0];
				this.RefreshData();
			},
			(error) => {
				this.RefreshData();
			}
		);
	}

	loadReportInboxCount() {
		var result = this.menuService.ReportInboxCountSelect();
		result.subscribe(
			(response: any) => {
				this.ReportInboxCount = response;
			},
			(error) => {}
		);
	}

	async RefreshData() {
		if (!this.SBMRefreshing) {
			this.SBMRefreshing = true;
			var ms = this.RefreshMinutes * 1000 * 60; //Default 5 minutes

			this.SBMInboxTimerSubscription = timer(ms, ms).subscribe((x) => {
				this.loadSBMInboxCount();
			});
		}
		if (!this.ReportRefreshing) {
			this.ReportRefreshing = true;
			var ms = this.RefreshMinutes * 1000 * 60; //Default 5 minutes

			this.ReportInboxTimerSubscription = timer(ms, ms).subscribe((x) => {
				this.loadReportInboxCount();
			});
		}
	}

	onClickSingleItem(appItem) {
		// console.log("Click Single Item");
		// console.log(appItem);

		//Home Page
		if (String(appItem.ApplicationItemID).toUpperCase() == "66BE93F8-392E-4DDA-A9CD-1DCF19123088") {
			this.CheckTop5();
		}
	}

	CheckTop5() {
		if (this.SchoolID == undefined) {
			return;
		}

		var result = this.menuService.Top5SelectAnyError(this.SchoolID);
		result.subscribe(
			(response: any) => {
				if (response == true) {
					var ref = this.dialogService.open(Top5DialogComponent, {
						header: "Items Needing Administrator's Attention",
						width: "fit-content",
						data: {},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				}
			},
			(error) => {}
		);
	}

	onResetSearch(val) {
		//
		// Clear out filter when you minimize the nav bar
		// (So it doesn't hide everything)
		//
		if (val == true) {
			this.onSearchForChange("");
		}
	}

	onSearchForChange(val) {
		this.SearchFor = val;

		if (this.SearchFor != undefined && this.SearchFor != "") {
			this.Searching = true;

			this.FilterCheckList(this.applicationItemList, false);

			this.Searching = false;
		} else {
			this.FilterSetAll(true);
		}
	}

	FilterCheckList(ItemList, TopMatch): boolean {
		if (ItemList == undefined || ItemList.length == 0) {
			return false;
		}

		var anyMatch = false;

		for (var z = 0; z < ItemList.length; z++) {
			var next = ItemList[z];

			var nextMatch = this.FilterMatch(next) || TopMatch;
			var anyChildMatch = this.FilterCheckList(next.Children, nextMatch);

			next.FilterShow = nextMatch || anyChildMatch;

			anyMatch = anyMatch || nextMatch || anyChildMatch;
		}

		return anyMatch;
	}

	FilterSetAll(val) {
		for (var z = 0; z < this.applicationItemList.length; z++) {
			var top = this.applicationItemList[z];

			top.FilterShow = val;

			for (var x = 0; x < top.Children.length; x++) {
				var mid = top.Children[x];

				mid.FilterShow = val;

				for (var y = 0; y < mid.Children.length; y++) {
					var bottom = mid.Children[y];

					bottom.FilterShow = val;
				}
			}
		}
	}

	FilterMatch(Item: any): boolean {
		var name = String(Item.ApplicationItemName).toLowerCase();
		var str = String(this.SearchFor).toLowerCase();

		return name.indexOf(str) >= 0;
	}

	IsLoading() {
		return this.Searching == true;
	}

	SaveRouterLinks(data: any) {
		var lstRouterLink: string[] = this.GetRouterLinks(data);

		this.localService.setItem("lstRouterLink", lstRouterLink);
	}

	GetRouterLinks(data: any): string[] {
		var ans: string[] = [];

		for (var z = 0; z < data.length; z++) {
			var next = data[z];

			if (next.RouterLink != undefined) {
				ans = [...ans, next.RouterLink];
			}

			if (next.Children != undefined && next.Children.length != undefined) {
				ans = [...ans, ...this.GetRouterLinks(next.Children)];
			}
		}

		ans = ans.sort();

		return ans;
	}
}
